namespace advisorop.components.servicer {
    
    export class AccountMaintenanceServicerController{
        $router;
        accounts: any;
        selectedCompanyGroup: domains.ICompanyGroup;

        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {            
            
        }

        companyGroupSelected(companyGroup: domains.ICompanyGroup): void {
            this.selectedCompanyGroup = companyGroup;
            //console.log("u acc man servicer");
            //console.log(companyGroup);
        };


        loadUnmappedAccounts(selectedCompanyGroup: domains.ICompanyGroup): void {
            var rez = this.servicerService.getUnmappedAccounts(selectedCompanyGroup.ppFirmId);

            rez.then((data) => {
                this.accounts = data.data;
            }).catch((data) => {
                toastr.error("Error " + data.status + " " + data.data);
            });
        };

        
        $onInit(): void {
            //if (this.selectedCompanyGroup) {
            //    this.loadUnmappedAccounts(this.selectedCompanyGroup);
            //}                    
        }

        $routerOnActivate(next, previous) {          
        }        

    }



    class AccountMaintenanceServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AccountMaintenanceServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/account-maintenance-servicer.html';            
        }
    }
    angular.module(Constants.APP).component("accountMaintenanceServicer", new AccountMaintenanceServicer());
    
}